import { publicEnv } from '~/features/environment/public';
import { Currency } from '~/features/internationalization/models/currency';
import { queryUdacityService } from '~/utils/query-udacity-service';

import { MastersPrice, mastersPriceSchema } from '../models/masters-price';

export async function getMastersPrice(currency: Currency): Promise<MastersPrice> {
  return await queryUdacityService({
    url: `${publicEnv.NEXT_PUBLIC_BRAAVOS_URL}/prices?currency=${currency}&type=DegreeApplicationSku`,
    method: 'GET',
    zodSchema: mastersPriceSchema,
  });
}
